import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const allocateCustomer = async () => {
  const token = getToken();
  let valid = false;
  let result;

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/allocate_customer_reports`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors) {
      return {
        valid: false,
        message: result.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    customers: result.customers ? result.customers : [],
  };
};

export default allocateCustomer;
